import { cn } from '@utils/tailwind.utils'
import { VERIFY_LOADER_KIND, VERIFY_LOADING_ATTR } from '@utils/verifyLoading'
import { FC } from 'react'

interface AreaLoaderProps {
  className?: string
  height?: string
  width?: string
}

export const AreaLoader: FC<AreaLoaderProps> = ({
  className,
  width = '100%',
  height = '2rem',
}) => (
  <div
    className={cn('animate-pulse bg-[#AF96EF] rounded-xl', className)}
    style={{ width, height }}
    {...{ [VERIFY_LOADING_ATTR]: VERIFY_LOADER_KIND.skeleton }}
  />
)
